import { render, staticRenderFns } from "./AddSupplier.vue?vue&type=template&id=1712d422&scoped=true"
import script from "./AddSupplier.vue?vue&type=script&lang=js"
export * from "./AddSupplier.vue?vue&type=script&lang=js"
import style0 from "./AddSupplier.vue?vue&type=style&index=0&id=1712d422&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1712d422",
  null
  
)

export default component.exports